"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatFrequencySelect = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var constants_1 = require("../../constants");
var DROPDOWN_WIDTH = 100;
var RenderRepeatFrequencySelect = /** @class */ (function (_super) {
    tslib_1.__extends(RenderRepeatFrequencySelect, _super);
    function RenderRepeatFrequencySelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isRepeatFrequencyItemSelected = function (item) {
            return item.id === _this.props.repeatFrequency;
        };
        _this.getRepeatFrequencyItem = function (repeatFrequency) {
            var _a = _this.props, intl = _a.intl, repeatPeriod = _a.repeatPeriod;
            return {
                id: repeatFrequency,
                title: intl.formatMessage({
                    id: "dialogs.schedule.email.repeats.frequencies." + repeatFrequency,
                }, {
                    n: repeatPeriod,
                }),
            };
        };
        _this.getRepeatFrequencyItems = function () {
            return constants_1.FREQUENCY_TYPE.map(_this.getRepeatFrequencyItem);
        };
        _this.onRepeatFrequencyChange = function (item) {
            _this.props.onChange(item.id);
        };
        return _this;
    }
    RenderRepeatFrequencySelect.prototype.render = function () {
        var _this = this;
        var repeatFrequencyItems = this.getRepeatFrequencyItems();
        var repeatFrequencyItem = repeatFrequencyItems.find(this.isRepeatFrequencyItemSelected);
        return (React.createElement(sdk_ui_kit_1.Dropdown, { alignPoints: constants_1.DEFAULT_DROPDOWN_ALIGN_POINTS, className: "gd-schedule-email-dialog-repeat-frequency s-gd-schedule-email-dialog-repeat-frequency", renderButton: function (_a) {
                var toggleDropdown = _a.toggleDropdown;
                return (React.createElement(sdk_ui_kit_1.DropdownButton, { value: repeatFrequencyItem.title, onClick: toggleDropdown }));
            }, renderBody: function (_a) {
                var closeDropdown = _a.closeDropdown, isMobile = _a.isMobile;
                return (React.createElement(sdk_ui_kit_1.DropdownList, { width: DROPDOWN_WIDTH, items: repeatFrequencyItems, isMobile: isMobile, renderItem: function (_a) {
                        var item = _a.item;
                        return (React.createElement(sdk_ui_kit_1.SingleSelectListItem, { title: item.title, onClick: function () {
                                _this.onRepeatFrequencyChange(item);
                                closeDropdown();
                            }, isSelected: repeatFrequencyItem.id === item.id }));
                    } }));
            }, overlayPositionType: "sameAsTarget", overlayZIndex: constants_1.DEFAULT_DROPDOWN_ZINDEX }));
    };
    return RenderRepeatFrequencySelect;
}(React.PureComponent));
exports.RepeatFrequencySelect = react_intl_1.injectIntl(RenderRepeatFrequencySelect);
//# sourceMappingURL=RepeatFrequencySelect.js.map